import React from 'react';
import { generatePath, useHistory, useParams } from 'react-router-dom';

import ChooseScreen from 'components/SearchTools/ChooseScreen';
import useEditPermission from 'lib/access/useEditPermission';
import { toDateString } from 'lib/dates/dateUtils';
import { Id } from 'lib/types';
import PortfoliosDropdown from 'screens/Backtest/lib/components/PortfoliosDropdown';
import { useBacktestsQuery, useDeleteBacktestMutation } from 'screens/Backtest/lib/queries';
import { Backtest } from 'screens/Backtest/lib/types';
import { usePortfolioQuery } from 'screens/Portfolio/lib/queries';
import { Routes } from 'utils/constants';

const translationPath = 'chooseBacktestsScreen';

const columns = ['id', 'name', 'createdOn', 'updatedOn'];

const ChooseBacktestsScreen = () => {
  const history = useHistory();
  const { id, portfolioId } = useParams<{ id: Id | undefined; portfolioId: Id | undefined }>();
  const { backtests } = useBacktestsQuery(portfolioId);
  const { mutate: deleteBacktest } = useDeleteBacktestMutation();
  const { portfolio, isLoading } = usePortfolioQuery(portfolioId);
  const hasCreatePermission = useEditPermission(portfolio);

  const handleChangePortfolioId = (newPortfolioId: Id) => {
    history.push(
      generatePath(Routes.CHOOSE_BACKTEST_WITH_PORTFOLIO, {
        portfolioId: newPortfolioId,
        id,
      })
    );
  };

  const cellFormatting = {
    createdOn: toDateString,
    updatedOn: toDateString,
  };

  return (
    <ChooseScreen
      dialogTranslatePath='backtestScreen.useSavePromptAndDialog'
      returnButtonProps={
        portfolioId
          ? {
              translateId: `${translationPath}.returnButtonToPortfolio`,
              route: generatePath(Routes.PORTFOLIO, { id: portfolioId }),
            }
          : undefined
      }
      topScreen={
        <PortfoliosDropdown onChange={handleChangePortfolioId} portfolioId={portfolioId} />
      }
      waitWhile={isLoading}
      key={translationPath}
      tableObjects={backtests}
      // @ts-ignore
      columns={columns}
      searchColumns={columns}
      cellFormatting={cellFormatting}
      searchValue={null}
      translationPath={translationPath}
      isTableWhite
      onNewClick={
        hasCreatePermission
          ? () => history.push(generatePath(Routes.NEW_BACKTEST, { portfolioId, id }))
          : undefined
      }
      onRowClick={(clickedId: Id) =>
        history.push(generatePath(Routes.BACKTEST_WITH_PORTFOLIO, { id: clickedId, portfolioId }))
      }
      onDeleteRowClick={(obj: Backtest) => {
        deleteBacktest(obj.id);
      }}
      editPermissionOverride={hasCreatePermission}
    />
  );
};

export default ChooseBacktestsScreen;
